import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../components/layout';
import Helmet from 'react-helmet';
import mainimg from '../images/mainimg.svg';
import mainimg_sp from '../images/mainimg_sp.svg';
import lead_img from '../images/lead_img.svg';
import lead_img_sp from '../images/lead_img_sp.svg';
import s_ttl from '../images/s_ttl.svg';
import s_ttl_sp from '../images/s_ttl_sp.svg';
import box01_ttl_pc from '../images/box01_ttl_pc.svg';
import box01_ttl_sp from '../images/box01_ttl_sp.svg';
import box04_ttl_pc from "../images/box04_ttl_pc.svg"
import box04_ttl_sp from '../images/box04_ttl_sp.svg';
import box05_ttl_pc from "../images/box05_ttl_pc.svg"
import box05_ttl_sp from '../images/box05_ttl_sp.svg';
import box06_2_ttl_pc from '../images/box06-2_ttl_pc.svg';
import box06_2_ttl_sp from '../images/box06-2_ttl_sp.svg';

if (process.env.PRODUCTION) {
    // Variables for analytics tools
    global.channel = 'Career-LP'; //category_l1
    global.prop1 = 'Career-LP-Firebase'; //category_l2
    global.prop2 = ''; //category_l3
    global.prop3 = ''; //content_name
    global.prop14 = ''; //content_id
}

const IndexPage = () => (
  <Layout>
    <Helmet>
      <title>転職も、日経｜転職は情報戦｜日経転職版</title>
      <meta charset="UTF-8" />
      <meta content="width=device-width, initial-scale=1.0" name="viewport" />
      <meta content="website" property="og:type" />
      <link href="" rel="canonical" />
      <meta
        name="keywords"
        content="転職,転職サイト,日経,求人,求人情報,転職情報,日経転職版"
      />
      <meta name="description" content="" />
      <meta property="fb:app_id" content="746352916179091" />
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="日経転職版" />
      <meta property="og:url" content="" />
      <meta
        property="og:title"
        content="転職も、日経｜転職は情報戦｜日経転職版"
      />
      <meta property="og:image" content="" />
      <meta property="og:description" content="" />
      <meta property="og:site_name" content="日経転職版" />
      <meta
        name="twitter:title"
        content="転職も、日経｜転職は情報戦｜日経転職版"
      />
      <meta name="twitter:description" content="" />
      <meta name="twitter:site" content="@career_nikkei" />
      <meta name="twitter:card" content="summary" />
    </Helmet>
    <main>
      <div class="mainimg">
        <div class="inner">
          <h1>
            <picture>
              <source srcSet={mainimg_sp} media="(max-width: 767px)" />
              <img src={mainimg} alt="転職は情報戦。だから、日経転職版。" />
            </picture>
          </h1>
        </div>
      </div>
      <div class="entryBox bt">
        <p>
          会員登録すると、メガベンチャー、上場企業など、
          <br class="hid-pc" />
          多数の非公開求人をご覧いただけます。
        </p>
        <div class="inner">
          <div class="transitionBtn">
            <a
              href="https://career.nikkei.com/career/MEFD001/MEFD00101.htm"
              target="_blank"
              rel="noreferrer"
            >
              会員登録はこちら<span>無料</span>
            </a>
          </div>
        </div>
      </div>
      <div class="entryBox in">
        <div class="inner">
          <p>
            会員登録すると、メガベンチャー、上場企業など、
            <br class="hid-pc" />
            多数の非公開求人をご覧いただけます。
          </p>
          <div class="transitionBtn">
            <a
              href="https://career.nikkei.com/career/MEFD001/MEFD00101.htm"
              target="_blank"
              rel="noreferrer"
            >
              会員登録はこちら<span>無料</span>
            </a>
          </div>
        </div>
      </div>
      <div class="gray-wrap">
        <div class="leadBox inner">
          <p>
            <picture>
              <source srcSet={lead_img_sp} media="(max-width: 767px)" />
              <img
                src={lead_img}
                placeholder="none"
                alt="日経だからこその、価値ある情報。"
              />
            </picture>
          </p>
        </div>
        <div class="graphBaox graphbox01 inner">
          <dl>
            <dt>
              <StaticImage
                src="../images/graphbox01_txt.svg"
                placeholder="none"
                alt="転職にも、正確で鮮度の高い日系の情報を。"
              />
            </dt>
            <dd>
              日経会社情報DIGITALとの連携で、企業の業績・財務データや人事情報、プレスリリースなど、転職活動に欠かせない情報にワンストップでアクセス・閲覧可能です。
              <br />
              <font size="2" font color="#696969">
                ※本情報が未掲載の企業もあります。
              </font>
            </dd>
          </dl>
          <figure>
            <StaticImage
              src="../images/graphbox01_img.png"
              placeholder="none"
              alt="売上高・当期利益"
            />
          </figure>
        </div>
        <div class="graphBaox graphbox02 inner">
          <figure>
            <StaticImage
              src="../images/graphbox02_img.png"
              placeholder="none"
              alt="売上高・当期利益"
            />
          </figure>
          <dl>
            <dt>
              <StaticImage
                src="../images/graphbox02_txt.svg"
                placeholder="none"
                alt="転職にも、正確で鮮度の高い日経の情報を。"
              />
            </dt>
            <dd>
              登録すると、最適なエージェントがすぐに提示される「ファスト・マッチ機能」。徹底的に無駄を省いた効率的な転職活動のために、使うほど実感できるスピード感を提供します。
              <br />
              <font size="2" font color="#696969">
                ※すべての会員にサービス提供する訳ではございません。
              </font>
            </dd>
          </dl>
        </div>
      </div>
      <div class="companyList">
        <div class="leadBox inner">
          <p class="performance">
            <StaticImage
              src="../images/lead_img02.svg"
              placeholder="none"
              alt="求人企業実績"
            />
          </p>
        </div>
        <div class="inner">
          <p class="com-list">
            <picture>
              <source srcSet={s_ttl_sp} media="(max-width: 767px)" />
              <img
                src={s_ttl}
                placeholder="none"
                alt="年収800万以上のハイクラス求人や、部長級の募集も多数掲載中。"
              />
            </picture>
          </p>
          <ul>
            <li>
              <picture>
                <source srcSet={box01_ttl_sp} media="(max-width: 767px)" />
                <img
                  src={box01_ttl_pc}
                  placeholder="none"
                  alt="トヨタ自動車株式会社"
                />
              </picture>
              <span>
                企画・マーケティング職から、IT・Web・ネットワークエンジニア職、電気・電子・機械系エンジニア職まで、幅広く募集中。
              </span>
            </li>
            <li>
              <picture>
                <source srcSet={box04_ttl_sp} media="(max-width: 767px)" />
                <img
                  src={box04_ttl_pc}
                  placeholder="none"
                  alt="富士通株式会社"
                />
              </picture>
              <span>
                営業職から、IT・Web・ネットワークエンジニアなどの技術職、購買・物流に携わる部署まで、幅広く募集中。
              </span>
              <span class="num">
                <StaticImage
                  src="../images/box04_num_pc.svg"
                  placeholder="none"
                  alt="年収400～900万円"
                />
              </span>
            </li>
            <li>
              <picture>
                <source srcSet={box05_ttl_sp} media="(max-width: 767px)" />
                <img
                  src={box05_ttl_pc}
                  placeholder="none"
                  alt="アクセンチュア株式会社"
                />
              </picture>
              <span>
                人事・財務・法務部門の管理職からマーケティング職、コンサルタント職、IT・Web・ネットワークエンジニアなど技術職まで幅広く募集中。
              </span>
              <span class="num">
                <StaticImage
                  src="../images/box05_num_pc.svg"
                  placeholder="none"
                  alt="年収500～2,000万円"
                />
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="entryBox_btm">
        <div class="inner">
          <p>
            会員登録すると、メガベンチャー、上場企業など、多数の非公開求人をご覧いただけます。
          </p>
          <div class="transitionBtn">
            <a
              href="https://career.nikkei.com/career/MEFD001/MEFD00101.htm"
              target="_blank"
              rel="noreferrer"
            >
              会員登録はこちら<span>無料</span>
            </a>
          </div>
        </div>
      </div>

    </main>
  </Layout>
);

export default IndexPage;
